import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, Paper, Typography } from '@mui/material';
import IYDataForm from './IYDataForm';
import { cavinKareLogo } from '../assets/images';

function StandaloneIYForm() {
  const { id } = useParams();

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: '#edf4fd',
      py: 4
    }}>
      <Container maxWidth="md">
        <Paper
          elevation={2}
          sx={{
            borderRadius: 3,
            overflow: 'hidden',
            bgcolor: 'white'
          }}
        >
          <Box sx={{
            bgcolor: '#019383',
            color: 'white',
            p: 4,
            textAlign: 'center'
          }}>
            <Typography variant="h4" sx={{ fontWeight: 600, mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, fontSize: { xs: '1.1rem', sm: '1.5rem', md: '2rem' } }}>
              <Box sx={{ bgcolor: "white", p: 0.5, borderRadius: 1 }}><img src={cavinKareLogo} alt="Logo" style={{ height: 'auto', maxHeight: '40px', width: 'auto' }} className="form-logo" /></Box> - Influencer's OnBoarding Form
            </Typography>
          </Box>

          <Box sx={{ p: 4 }}>
            <IYDataForm />
          </Box>
        </Paper>

        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="body2" color="text.secondary">
            Powered by HEPL
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default StandaloneIYForm;
